import http from "@/api/http";

export default {
  getCards() {
    return http({ url: "/cards", method: "get" });
  },
  addUserCard(data) {
    return http({ url: "/cards", method: "post", data: data });
  },
  deleteCard(idCard) {
    return http({
      url: "/cards/" + idCard,
      method: "delete",
      data: { id: idCard }
    });
  }
};
